import { environment } from '.'

export const isDevelopment = environment.NODE_ENV === 'development'
